import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { FundInvestmentMarketAdjustmentCellData } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet';

const normalizeHiddenCell = (cell: ICell<FundInvestmentMarketAdjustmentCellData>): void => {
  Object.assign(cell, {
    allowEmptyValues: true,
    dbType: 'string',
    gridType: 'string',
    isRequired: false,
    readOnly: true,
    value: '',
  });
};

export default normalizeHiddenCell;
